





















































import {Component, Vue, Watch} from 'vue-property-decorator';
import FlipCountdown from 'vue2-flip-countdown';
import xmlParse from "xml-parser-xo";
@Component({
  components: {FlipCountdown}
})
export default class Home extends Vue {
  private insertData: string = "";
  private validation: boolean = true;
  private errorInputText: any = null;

  @Watch('insertData')
  watchText(newText: string){
    this.validation = this.validated(newText);
  }

  runFormat(){
    this.$store.commit('setFormatData', this.insertData);
    this.$router.push('formatter');
  }

  validated(insertData: string){
    if(insertData === "") return false;
    let valid: boolean = false;
    try{
      JSON.parse(insertData);
      valid = true;
    }catch (e){
      this.errorInputText = e;
      valid = false;
    };
    // if(!valid) {
    //   try {
    //     this.xmlDom = xmlParse(insertData);
    //     valid = true;
    //   } catch (e) {
    //     this.errorInputText = e;
    //     this.openModal = true;
    //     valid = false;
    //   };
    // }
    return valid;
  }
};
